import { Component, OnInit } from '@angular/core';
import { NgxPermissionsService, NgxRolesService } from 'ngx-permissions';
require('devextreme-intl');
const esMessages = require('devextreme/localization/messages/es.json');
const localization = require('devextreme/localization');
import config from 'devextreme/core/config';
import { AuthService } from '@app/services/auth.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {
  tab: Number = 1;
  idmodulo: String = 'resbar';
  EstadosFitl = [];
  _Permisoss: any = [];
  _Acciones: any = [];
  _Perfiles: any = [];
  _Array_acciones: any = [];
  _Modulos: any = [];
  _Array_modulos: any = [];
  _Perfiles_modulo: any = [];
  public dataUser: any = {}


  constructor(
    private permissionService: NgxPermissionsService,
    private _AuthService: AuthService,
  ) {
    localization.loadMessages(esMessages);
    localization.locale(navigator.language);
    config({ defaultCurrency: 'COP' });
  }

  ngOnInit() {
    this.cargarDataUsuario();
  }
  cargarDataUsuario() {
    this._AuthService.cargarDataUsuario({}, data => {
      var dat = data.decodeToken.sub

      this.dataUser.nombre = dat.primer_nombre + ' ' + dat.segundo_nombre + ' ' + dat.primer_apellido
      this.dataUser.id = dat.id
      this.dataUser.perfil = dat.perfil
    })
  }
}
